import React from 'react'

const SocialIcons = () => {
  return (
    <div className="social-links d-flex mt-3 gap-3">
      <a href="https://github.com/MalinkaMell" target="_blank" rel="noopener noreferrer" className="text-accent">
        <i className="bi bi-github"></i>
      </a>
      <a href="https://www.linkedin.com/in/irina-kudosova/" target="_blank" rel="noopener noreferrer" className="text-accent">
        <i className="bi bi-linkedin"></i>
      </a>
      <a href="mailto:irinakudosova@gmail.com" className="text-accent">
        <i className="bi bi-envelope"></i>
      </a>
    </div>
  )
}

export default SocialIcons